import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {addYears} from "date-fns";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import ServiceRequestListType from "./subpage/ServiceRequestListType";
import {selectServiceRequest} from "../../../api/serviceRequest/ServiceRequestService";
import useRequestData from "../../../hooks/useRequestData";
import {useDispatch} from "react-redux";
import ServiceRequestThumbType from "./subpage/ServiceRequestThumbType";
import MobileCreateButton from "../../../components/buttons/MobileCreateButton";
import {CHART_REGISTRY} from "../../../components/AiComponents/ChartRegistry";

/**
    서비스요청 - 서비스요청관리
 */
const ServiceRequestList = () => {
    const [listType, setListType] = useState(true);
    const dp = useDispatch();

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const {data, newData, pageInfo, dataHook} = useRequestData(selectServiceRequest, initDate, "service_request");

    return (
        <div className={"common-container"}>
            <PageHeader header={"접수신청/관리"} indicator={"서비스요청 > 접수신청/관리"} keys={CHART_REGISTRY.service.key}  />
            {listType ?
                <ServiceRequestListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
                :
                <ServiceRequestThumbType data={data} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
            }

            <MobileCreateButton  url={'/serviceRequest/serviceRequest/create'} userCheck />
        </div>
    );
};

export default ServiceRequestList;